import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import UpcomingMatches from '../Match/components/UpcominMatches';
import Config from "../../Utility/Config";
import Utility from "../../Utility/Utility";

import {
    getPlayerListApi,
    getCoachListApi,
    createTeamApi,
    getTeamDetailsApi
} from "./TeamController";
import { imageUploadApi, getCountryApi } from "../../Login/Controller/LoginController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MatchList from "../Match/components/MatchList";
import { getMatchListApi } from "../Match/MatchController";

const TeamManagement = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { language } = useSelector((state) => state.language);
    const { userDetails, token, userType } = useSelector((state) => state.user);
    const [teamDetails, setTeamDetails] = useState({});

    console.log("teamDetailsteamDetailsteamDetailsteamDetails", teamDetails);


    // ------------------ COUNTRY DROPDOWN ------------------
    const [openCountry, setOpenCountry] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("");
    console.log("selectedCountryselectedCountryselectedCountry", selectedCountry)
    const countryRef = useRef(null);

    const [playerList, setPlayerList] = useState([]);
    const [coachList, setCoachList] = useState([]);
    const [countries, setCountryList] = useState([]);
    const [teamsPlayer, setTeamsPlayer] = useState([]);
    const [matchList, setMatchList] = useState([]);
    console.log("playerListplayerListplayerList", playerList);

    const [teamData, setTeamData] = useState({
        name: "",
        coach: "",
        country: "",
        playersId: [],
        logo: "",
        shortName: "",
    });

    const [teamError, setLoginError] = useState({
        name: "",
        coach: "",
        country: "",
        playersId: "",
        logo: "",
        shortName: "",
    });

    const activeCountry = countries.find(
        (item) => item._id === selectedCountry
    );

    useEffect(() => {
        getPlayerList();
        getCountryList();
        getTeamDetails();
        getMatchList();
    }, []);

    const getTeamDetails = () => {
        let teamId = userDetails?.team?._id;

        try {
            dispatch(loaderStateTrue());
            getTeamDetailsApi(teamId)
                .then((response) => {
                    let responseData = response.data || {};
                    setTeamDetails(responseData);
                    setTeamData(responseData);
                    setSelectedCountry(responseData?.country?._id)
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getPlayerList = async () => {
        try {
            dispatch(loaderStateTrue());

            const response = await getPlayerListApi();
            const data = response?.data || [];

            // Format players by position
            const grouped = data.reduce((acc, player) => {
                (player.position || []).forEach(pos => {
                    let group = acc.find(g => g.position === pos);

                    if (!group) {
                        group = { position: pos, players: [] };
                        acc.push(group);
                    }

                    group.players.push({
                        ...player
                        // _id: player._id,
                        // fullName: player.fullName,
                        // dateOfBirth: player.dob,
                        // nationality: player.nationality || "",
                    });
                });
                return acc;
            }, []);

            setPlayerList(grouped);

        } catch (error) {
            console.log("Error fetching players:", error);
        } finally {
            dispatch(loaderStateFalse());
        }
    };

    const getCountryList = () => {
        try {
            dispatch(loaderStateTrue());
            getCountryApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setCountryList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getCoachList = () => {
        try {
            dispatch(loaderStateTrue());
            getCoachListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setCoachList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getMatchList = () => {
        try {
            dispatch(loaderStateTrue());
            getMatchListApi()
                .then((response) => {
                    let responseData = response.data?.result || [];
                    console.log("responseDataresponseDataresponseData", responseData)
                    setMatchList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    // ------------------ USER DROPDOWN ------------------
    const [openUser, setOpenUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState("JOHN");

    console.log("selectedUserselectedUserselectedUser", selectedUser);
    const userRef = useRef(null);
    const activeUser = coachList.find((coach) => coach._id === selectedUser);

    console.log("activeUseractiveUseractiveUser", activeUser);

    // ------------------ CLICK OUTSIDE CLOSE ------------------
    useEffect(() => {
        function handleClickOutside(e) {
            if (countryRef.current && !countryRef.current.contains(e.target)) {
                setOpenCountry(false);
            }
            if (userRef.current && !userRef.current.contains(e.target)) {
                setOpenUser(false);
            }
            if (userRef.current && !userRef.current.contains(e.target)) {
                setOpenUser(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // ------------------ PLAYER DROPDOWN ------------------
    const [openPlayer, setOpenPlayer] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState("VIRAT");
    const playerRef = useRef(null);

    const activePlayer = playerList.find((item) => item._id === selectedPlayer);

    const [teamOpen, setTeamOpen] = useState(false);
    const teamRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (teamRef.current && !teamRef.current.contains(e.target)) {
                setTeamOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (playerRef.current && !playerRef.current.contains(event.target)) {
                setOpenPlayer(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelectPlayer = (element) => {
        if (!element) {
            setLoginError((prev) => ({
                ...prev,
                playersId: "Please select a player",
            }));
            return;
        }

        setTeamsPlayer((prev) => [...prev, element]);
        setPlayerList((prev) => prev.filter((player) => player.id !== element.id));
        setTeamData((prev) => ({
            ...prev,
            playersId: [...(prev.playersId || []), element.id],
        }));
        setLoginError((prev) => ({ ...prev, playersId: "" }));
        setOpenPlayer(false);
        setSelectedPlayer(element.id);
    };

    const validateLogin = () => {
        let valid = true;
        if (teamData.name.trim() === "") {
            valid = false;
            setLoginError({ ...teamError, name: t("requiredField") });
        } else {
            setLoginError({ ...teamError, name: "" });
        }
        if (teamData.coach.trim() === "") {
            valid = false;
            setLoginError({ ...teamError, coach: t("requiredField") });
        } else {
            setLoginError({ ...teamError, coach: "" });
        }
        if (teamData.country.trim() === "") {
            valid = false;
            setLoginError({ ...teamError, country: t("requiredField") });
        } else {
            setLoginError({ ...teamError, country: "" });
        }
        return valid;
    };

    const handleCreate = () => {
        let valid = validateLogin();
        if (valid) {
            dispatch(loaderStateTrue());
            createTeamApi(teamData)
                .then(async (response) => {
                    console.log("responseresponseresponseresponse", response)
                    if (response.status) {
                        setTimeout(() => {
                            dispatch(loaderStateFalse());
                            navigate(`/${language}/team-management`);
                        }, 1000);
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        dispatch(loaderStateFalse());
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    Utility.toastNotifications(
                        error.response.data.message,
                        "Error",
                        "error"
                    );
                    if (error.response.status === 401) {
                        Utility.toastNotifications(
                            error.response.data.message,
                            "Error",
                            "error"
                        );
                    }
                    dispatch(loaderStateFalse());
                });
        }
    };

    const handleImageUpload = (file) => {
        dispatch(loaderStateTrue());
        imageUploadApi(file)
            .then((response) => {
                if (response.status) {
                    console.log("responseresponseresponse", response)
                    setTeamData((prev) => ({
                        ...prev,
                        logo: response.data?.url || "",
                    }));
                    dispatch(loaderStateFalse());
                    Utility.toastNotifications(response.message, "Success", "success");
                } else {
                    dispatch(loaderStateFalse());
                    Utility.toastNotifications(response.message, "Error", "error");
                }
            })
            .catch((error) => {
                dispatch(loaderStateFalse());
                Utility.toastNotifications("Upload failed", "Error", "error");
            });
    };

    const PrevArrow = ({ className, onClick }) => (
        <button className={`${className} !left-0 z-10`} onClick={onClick} type="button">
            <img
                src="../../assets/images/icons/arrow-chevron-left.svg"
                alt="prev"
                className="w-6 h-6"
            />
        </button>
    );

    const NextArrow = ({ className, onClick }) => (
        <button className={`${className} !right-0 z-10`} onClick={onClick} type="button">
            <img
                src="../../assets/images/icons/arrow-chevron-right.svg"
                alt="next"
                className="w-6 h-6"
            />
        </button>
    );

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 1 }
            },
            {
                breakpoint: 640,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    return (
        <main className="main p-4 relative">
            <div className="flex flex-col">
                <div className="flex flex-wrap items-start gap-y-6 -mx-2">
                    <div className="lg:w-4/6 w-full px-2">
                        <div className="space-y-5">
                            <div className="relative">
                                <div className="relative rounded-xl bg-gray-50 h-full">
                                    <div className='absolute inset-0 rounded-xl overflow-hidden'>
                                        <div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute -top-[1vw] -right-[2vw] opacity-80"></div>
                                        <div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute -top-[6vw] right-[5vw]"></div>
                                        <div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute -bottom-[6vw] right-[15vw]"></div>
                                    </div>
                                    <div className="flex max-sm:flex-wrap gap-3 justify-between relative">
                                        <div className="p-5 flex flex-col items-start justify-center [&_h1_strong]:text-primary-500 space-y-3 [&_strong]:text-primary-500">
                                            <div className="space-y-2">
                                                <h2 className="lg:text-4xl md:text-3xl text-xl font-black uppercase">fixture  management</h2>
                                                <p className='text-base font-medium text-gray-400'>Dummy text of the printing and typesetting industry.</p>
                                            </div>
                                        </div>
                                        <div className="lg:-mt-4 text-center">
                                            <img src="assets/images/teams.png" alt="" className="w-full inline-block rounded-br-xl" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap gap-y-4 -mx-2">
                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">Team Name</label>
                                    {/* <input type="text" className="form-control" /> */}
                                    <input
                                        type="text"
                                        id="name"
                                        // placeholder={t("email")}
                                        placeholder="Team Name"
                                        className="form-control"
                                        onChange={(e) => {
                                            setTeamData({ ...teamData, name: e.target.value });
                                            setLoginError({ ...teamError, name: "" });
                                        }}
                                        value={teamData.name}
                                    />
                                    <span className="text-red-500">{teamError.name}</span>
                                </div>

                                <div className="xs:w-1/2 w-full px-2">
                                    <label className="form-label">Country</label>

                                    <div className="dropdown border rounded-lg bg-white relative">
                                        <div className="relative z-[1]" ref={countryRef}>
                                            <button
                                                className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                                                onClick={() => setOpenCountry(!openCountry)}
                                            >
                                                <img
                                                    src={activeCountry?.flag}
                                                    className="size-6 rounded-full"
                                                    alt=""
                                                />
                                                <span>{activeCountry?.name}</span>

                                                <img
                                                    src="assets/images/icons/arrow-chevron-downward.svg"
                                                    className={`ml-auto transition-transform ${openCountry ? "rotate-180" : ""
                                                        }`}
                                                    alt=""
                                                />
                                            </button>

                                            {/* Country Menu */}
                                            <div
                                                className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-80 overflow-auto transition-all
                                        ${openCountry
                                                        ? "opacity-100 visible scale-100"
                                                        : "opacity-0 invisible scale-95"
                                                    }`}
                                            >
                                                <ul>
                                                    {countries.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedCountry === item.name
                                                                    ? "bg-gray-200 font-semibold"
                                                                    : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedCountry(item.name);
                                                                setTeamData({
                                                                    ...teamData,
                                                                    country: item._id,
                                                                });
                                                                setLoginError({ ...teamError, country: "" });
                                                                setOpenCountry(false);
                                                            }}
                                                        >
                                                            <img src={item.flag} className="size-5" alt="" />
                                                            {item.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-red-500">{teamError.country}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full px-2">
                                    <div className="flex items-center justify-center w-full">
                                        <label
                                            for="dropzone-file"
                                            className="flex flex-col items-center justify-center w-full h-48 bg-neutral-secondary-medium border-2 border-dashed border-default-strong border-gray-200 rounded-xl cursor-pointer hover:bg-neutral-tertiary-medium"
                                        >
                                            <div className="flex flex-col items-center justify-center text-body pt-5 pb-6">
                                                <div className="bg-gradient-to-r from-primary-500 via-primary-700 to-primary-950 text-white rounded-full p-1 size-8 flex justify-center items-center">
                                                    <img
                                                        src="assets/images/icons/plus.svg"
                                                        alt=""
                                                        className="icon-white flex-none size-full"
                                                    />
                                                </div>
                                                <plabel className="my-2 uppercase">
                                                    <span className="font-semibold">Add a Team logo</span>
                                                </plabel>
                                                <p className="font-medium text-gray-400">
                                                    Dummy text of the printing and typesetting industry.
                                                </p>
                                            </div>
                                            <input
                                                id="dropzone-file"
                                                type="file"
                                                className="hidden"
                                                onChange={(e) => handleImageUpload(e.target.files[0])}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap items-start gap-4 p-3 rounded-lg bg-gray-50">
                                <div>
                                    <h3 className="text-lg font-extrabold uppercase">Notes</h3>
                                    <p className="text-gray-400">
                                        Lorem Ipsum is simply dummy text of the printing and
                                        typesetting industry.
                                    </p>
                                </div>
                                {/* <button className="btn btn-primary text-nowrap ml-auto">Proceed</button> */}

                                <button
                                    className="btn btn-primary text-nowrap ml-auto"
                                    // onClick={() => navigate("/en/team-management")}
                                    onClick={handleCreate}
                                >
                                    Update
                                </button>
                            </div>
                            <div className="flex justify-between items-center gap-3">
                                <div>
                                    <h3 className="xl:text-2xl text-xl font-extrabold uppercase">Select Team formation</h3>
                                    <p className='text-gray-400'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
                                <select className="form-select font-bold !max-w-[200px]">
                                    <option value="">4-4-3</option>
                                    <option value="">3-4-3</option>
                                    <option value="">4-3-4</option>
                                </select>
                            </div>

                            <div className="overflow-x-auto space-y-4">
                                {playerList.map((element, index) => (
                                    <table key={index} className="table table-striped table-row-hover w-full">
                                        <thead className="border-b light-border">
                                            <tr>
                                                <th className="text-lg font-bold" colSpan={4}>{element.position} - {element.players.length}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {element?.players.map((childElement, index) => (
                                                <tr key={index}>
                                                    <td width={32} className='w-20'>
                                                        <label className="relative inline-flex items-center gap-1.5 cursor-pointer">
                                                            <input type="checkbox" className="input-checkbox" checked={childElement?.teamJoinStatus === "approved"} />
                                                            <span className="font-secondary font-semibold text-nowrap">#1</span>
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <div className="flex max-sm:flex-wrap items-center gap-3">
                                                            <div className="w-10">
                                                                <img className="w-full" src="assets/images/players-list/4.png" alt="" />
                                                            </div>
                                                            <div>
                                                                <p className="font-bold uppercase">{childElement?.fullName}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className='text-right'>
                                                        <span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
                                                            <img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 4.5
                                                        </span>
                                                    </td>
                                                    {/* <td className='text-right'>
                                                    <span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-yellow-500">
                                                        <img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 2.5
                                                    </span>
                                                </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>))}
                            </div>

                            <div className="flex flex-wrap items-start gap-4 p-3 rounded-lg bg-gray-50">
                                <div>
                                    <h3 className="text-lg font-extrabold uppercase">Manage team</h3>
                                    <p className="text-gray-400">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
                                {/* <button className="btn btn-primary text-nowrap ml-auto">Preview</button> */}
                                <button className="btn btn-primary text-nowrap ml-auto" onClick={() => navigate("/en/preview")} >Preview</button>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
                        <div className="panel rounded-xl border light-border bg-white p-4 space-y-4">
                            <div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
                                <h3 className="xl:text-lg text-base font-extrabold uppercase">{t('upcomingMatches')}</h3>
                                <Link to={'../upcoming-matches'} className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
                            </div>
                            <div className="panel-body w-full">
                                <MatchList matchList={matchList} isUpcomming={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default TeamManagement